const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * A chart day in the UI language ("5 oct." / "Oct 5"). A date-only string is a
 * calendar day, so it is read in UTC: read locally it slips to the eve west of UTC.
 */
export const formatChartDay = (value: string | number | Date, locale: string): string => {
  // The chart tooltip asks for its label before any point is hovered: an
  // unreadable value writes nothing, since Intl throws on an invalid date.
  const date = value === '' || value == null ? null : new Date(value);
  if (!date || Number.isNaN(date.getTime())) return '';
  const isCalendarDay = typeof value === 'string' && DATE_ONLY.test(value);
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    ...(isCalendarDay && { timeZone: 'UTC' }),
  }).format(date);
};

/** An amount in the UI language ("84 320 €" / "€84,320"); `compact` suits an axis ("84 k €"). */
export const formatChartAmount = (
  value: number,
  currency: string,
  locale: string,
  { compact = false }: { compact?: boolean } = {}
): string =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...(compact && { notation: 'compact' }),
  }).format(value);

/** A whole count in the UI language ("12 500" / "12,500"). */
export const formatChartCount = (value: number, locale: string): string =>
  new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value);
